import React, { memo } from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import FloatButton from './FloatButton';
import Modal from './Modal';
import Icon from './Icon';
import { Color, FontSize, CommonProperties } from '../styles';
import { Modals, Screens } from '../constants/ScreenNames';
import { scale } from '../utils/scale.utils';
import BaseText from './BaseText';
import i18n from '../i18n';
import { useNavigation } from '@react-navigation/native';
import { REBOOK_ENABLED } from '../config/env';
const SearchFabMenuModal = ({ onClose, visible, title, onPress }) => {
  const navigation = useNavigation();

  return (
    <Modal
      animationType="fade"
      statusBarTranslucent={false}
      transparent={true}
      visible={visible}
      onRequestClose={onClose}
    >
      <View style={styles.darkTransparent}>
        {!!title && (
          <TouchableOpacity
            onPress={() => {
              onPress(0);
            }}
            style={styles.rowItem}
          >
            <Icon name="filter" style={styles.icon} />
            <BaseText style={styles.text}>{title}</BaseText>
          </TouchableOpacity>
        )}
        <TouchableOpacity
          onPress={() => {
            if (REBOOK_ENABLED) {
              navigation.navigate(Screens.RebookHome);
            } else {
              navigation.navigate(Modals.ResearchWidgetModal);
            }
            onClose();
          }}
          style={styles.rowItem}
        >
          <Icon name="search" style={styles.icon} />
          <BaseText style={styles.text}>
            {i18n.t('common:SearchFabMenuModal.ChangeSearch')}
          </BaseText>
        </TouchableOpacity>
        {/* <TouchableOpacity
          onPress={() => {
            onPress(2);
          }}
          style={styles.rowItem}
        >
          <Icon name="share" style={styles.icon} />
          <BaseText style={styles.text}>Share page</BaseText>
        </TouchableOpacity> */}
        <TouchableOpacity
          onPress={() => {
            navigation.navigate(Modals.AgentContact);
            onClose();
          }}
          style={styles.rowItem}
        >
          <Icon name="aiChat" style={styles.icon} />
          <BaseText style={styles.text}>
            {i18n.t('common:SearchFabMenuModal.ContactAgent')}
          </BaseText>
        </TouchableOpacity>
        <FloatButton onPress={onClose} iconName="cancel" />
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  darkTransparent: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(0,0,0,.4)',
    alignItems: 'center',
    justifyContent: 'center',
    ...CommonProperties.p3,
  },
  rowItem: {
    flexDirection: 'row',
    width: '100%',
    maxWidth: scale(370, 0.1),
    paddingLeft: scale(60, 0.1),
    backgroundColor: Color.accent,
    borderRadius: scale(30),
    marginBottom: scale(36, 0.1),
    ...CommonProperties.py3,
  },
  text: {
    color: Color.primary,
    ...CommonProperties.h2,
    lineHeight: FontSize.h2 * 1.1,
  },
  icon: {
    color: Color.primary,
    ...CommonProperties.h2,
    lineHeight: FontSize.h2 * 1.1,
    ...CommonProperties.mr5,
  },
});

export default memo(SearchFabMenuModal);
